/** Auto-generated route registry — Phase 1G / generate-screens */
import { lazy, Suspense, type ReactElement } from 'react';
import {
  Navigate,
  Outlet,
  useLocation,
  useParams,
  useRoutes,
  useSearchParams,
} from 'react-router-dom';
import { AuthLayout } from '@beatq/ui';
import { AdminShell } from '../shell/AdminShell.js';
import { NotFoundFallback } from '@beatq/shared';
import {
  caseDetailPath,
  customer360Path,
  deliveryTimelinePath,
  merchant360Path,
  orderInvestigatePath,
  paymentTracePath,
} from '../shell/subjectUrls.js';

const SCRADM001Page = lazy(() => import('../pages/SCR-ADM-001.js'));
const SCRADM002Page = lazy(() => import('../pages/SCR-ADM-002.js'));
const SCRADM003Page = lazy(() => import('../pages/SCR-ADM-003.js'));
const SCRADM004Page = lazy(() => import('../pages/SCR-ADM-004.js'));
const SCRADM005Page = lazy(() => import('../pages/SCR-ADM-005.js'));
const SCRADM006Page = lazy(() => import('../pages/SCR-ADM-006.js'));
const SCRADM007Page = lazy(() => import('../pages/SCR-ADM-007.js'));
const SCRADM008Page = lazy(() => import('../pages/SCR-ADM-008.js'));
const SCRADM009Page = lazy(() => import('../pages/SCR-ADM-009.js'));
const SCRADM010Page = lazy(() => import('../pages/SCR-ADM-010.js'));
const SCRADM011Page = lazy(() => import('../pages/SCR-ADM-011.js'));
const SCRADM012Page = lazy(() => import('../pages/SCR-ADM-012.js'));
const SCRADM013Page = lazy(() => import('../pages/SCR-ADM-013.js'));
const SCRADM014Page = lazy(() => import('../pages/SCR-ADM-014.js'));
const SCRADM015Page = lazy(() => import('../pages/SCR-ADM-015.js'));
const SCRADM016Page = lazy(() => import('../pages/SCR-ADM-016.js'));
const SCRADM017Page = lazy(() => import('../pages/SCR-ADM-017.js'));
const SCRADM018Page = lazy(() => import('../pages/SCR-ADM-018.js'));
const SCRADM019Page = lazy(() => import('../pages/SCR-ADM-019.js'));
const SCRADM020Page = lazy(() => import('../pages/SCR-ADM-020.js'));
const SCRADM021Page = lazy(() => import('../pages/SCR-ADM-021.js'));
const SCRADM022Page = lazy(() => import('../pages/SCR-ADM-022.js'));
const SCRADM023Page = lazy(() => import('../pages/SCR-ADM-023.js'));
const SCRADM024Page = lazy(() => import('../pages/SCR-ADM-024.js'));
const SCRADM025Page = lazy(() => import('../pages/SCR-ADM-025.js'));
const SCRADM026Page = lazy(() => import('../pages/SCR-ADM-026.js'));
const SCRADM027Page = lazy(() => import('../pages/SCR-ADM-027.js'));
const SCRADM028Page = lazy(() => import('../pages/SCR-ADM-028.js'));
const SCRADM029Page = lazy(() => import('../pages/SCR-ADM-029.js'));
const SCRADM030Page = lazy(() => import('../pages/SCR-ADM-030.js'));
const SCRADM031Page = lazy(() => import('../pages/SCR-ADM-031.js'));
const SCRADM034Page = lazy(() => import('../pages/SCR-ADM-034.js'));
const SCRADM035Page = lazy(() => import('../pages/SCR-ADM-035.js'));
const SCRADM036Page = lazy(() => import('../pages/SCR-ADM-036.js'));
const SCRADM037Page = lazy(() => import('../pages/SCR-ADM-037.js'));
const SCRADM038Page = lazy(() => import('../pages/SCR-ADM-038.js'));
const SCRADM039Page = lazy(() => import('../pages/SCR-ADM-039.js'));
const SCRADM040Page = lazy(() => import('../pages/SCR-ADM-040.js'));
const SCRADM041Page = lazy(() => import('../pages/SCR-ADM-041.js'));
const SCRADM042Page = lazy(() => import('../pages/SCR-ADM-042.js'));
const SCRADM043Page = lazy(() => import('../pages/SCR-ADM-043.js'));
const SCRADM044Page = lazy(() => import('../pages/SCR-ADM-044.js'));
const SCRADM045Page = lazy(() => import('../pages/SCR-ADM-045.js'));
const SCRADM046Page = lazy(() => import('../pages/SCR-ADM-046.js'));
const SCRADM047Page = lazy(() => import('../pages/SCR-ADM-047.js'));
const SCRADM048Page = lazy(() => import('../pages/SCR-ADM-048.js'));
const SCRADM049Page = lazy(() => import('../pages/SCR-ADM-049.js'));
const SCRADM050Page = lazy(() => import('../pages/SCR-ADM-050.js'));
const SCRADM051Page = lazy(() => import('../pages/SCR-ADM-051.js'));
const SCRADM052Page = lazy(() => import('../pages/SCR-ADM-052.js'));
const SCRADM057Page = lazy(() => import('../pages/SCR-ADM-057.js'));
const SCRADM058Page = lazy(() => import('../pages/SCR-ADM-058.js'));
const BeatqDelPricingPage = lazy(
  () => import('../features/platform-config/BeatqDelPricingPage.js'),
);
const BeatqDelRidesPage = lazy(() => import('../pages/SCR-ADM-055.js'));
const BeatPayOperationsPage = lazy(() =>
  import('../features/beat-pay-operations/BeatPayOperationsPage.js').then((module) => ({
    default: module.BeatPayOperationsPage,
  })),
);
const BeatPayAccountDetailPage = lazy(() =>
  import('../features/beat-pay-operations/BeatPayOperationsPage.js').then((module) => ({
    default: module.BeatPayAccountDetailPage,
  })),
);

export type LayoutShell = 'public' | 'auth' | 'account' | 'floor';

export interface ScreenRoute {
  screenId: string;
  path: string;
  layoutShell: LayoutShell;
  theme: 'standard' | 'floor' | 'dense';
  element: ReactElement;
}

export const screenRoutes: ScreenRoute[] = [
  {
    path: '/admin-sign-in',
    screenId: 'SCR-ADM-001',
    layoutShell: 'auth',
    theme: 'standard',
    element: <SCRADM001Page />,
  },
  {
    path: '/admin-dashboard',
    screenId: 'SCR-ADM-002',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM002Page />,
  },
  {
    path: '/case-queue',
    screenId: 'SCR-ADM-003',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM003Page />,
  },
  {
    path: '/case-detail',
    screenId: 'SCR-ADM-004',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM004Page />,
  },
  {
    path: '/case-macros',
    screenId: 'SCR-ADM-005',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM005Page />,
  },
  {
    path: '/cases/:caseId/macros',
    screenId: 'SCR-ADM-005',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM005Page />,
  },
  {
    path: '/cases/:caseId',
    screenId: 'SCR-ADM-004',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM004Page />,
  },
  {
    path: '/macro-management',
    screenId: 'SCR-ADM-006',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM006Page />,
  },
  {
    path: '/order-investigation',
    screenId: 'SCR-ADM-007',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM007Page />,
  },
  {
    path: '/payment-trace',
    screenId: 'SCR-ADM-008',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM008Page />,
  },
  {
    path: '/delivery-timeline',
    screenId: 'SCR-ADM-009',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM009Page />,
  },
  {
    path: '/customer-360',
    screenId: 'SCR-ADM-010',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM010Page />,
  },
  {
    path: '/merchant-360',
    screenId: 'SCR-ADM-011',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM011Page />,
  },
  {
    path: '/support-mirror',
    screenId: 'SCR-ADM-012',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM012Page />,
  },
  {
    path: '/impersonation',
    screenId: 'SCR-ADM-013',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM013Page />,
  },
  {
    path: '/issue-refund',
    screenId: 'SCR-ADM-014',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM014Page />,
  },
  {
    path: '/grant-goodwill',
    screenId: 'SCR-ADM-015',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM015Page />,
  },
  {
    path: '/waive-fee',
    screenId: 'SCR-ADM-016',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM016Page />,
  },
  {
    path: '/create-replacement',
    screenId: 'SCR-ADM-017',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM017Page />,
  },
  {
    path: '/cancel-order-support',
    screenId: 'SCR-ADM-018',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM018Page />,
  },
  {
    path: '/attribute-liability',
    screenId: 'SCR-ADM-019',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM019Page />,
  },
  {
    path: '/remedy-history',
    screenId: 'SCR-ADM-020',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM020Page />,
  },
  {
    path: '/escalate',
    screenId: 'SCR-ADM-021',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM021Page />,
  },
  {
    path: '/approval-inbox',
    screenId: 'SCR-ADM-022',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM022Page />,
  },
  {
    path: '/four-eyes-confirmation',
    screenId: 'SCR-ADM-023',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM023Page />,
  },
  {
    path: '/moderation-queue',
    screenId: 'SCR-ADM-024',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM024Page />,
  },
  {
    path: '/moderate-review/:itemId',
    screenId: 'SCR-ADM-025',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM025Page />,
  },
  {
    path: '/moderate-review',
    screenId: 'SCR-ADM-025',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM025Page />,
  },
  {
    path: '/moderate-content/:itemId',
    screenId: 'SCR-ADM-026',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM026Page />,
  },
  {
    path: '/moderate-content',
    screenId: 'SCR-ADM-026',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM026Page />,
  },
  {
    path: '/moderation-appeals/:itemId',
    screenId: 'SCR-ADM-027',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM027Page />,
  },
  {
    path: '/moderation-appeals',
    screenId: 'SCR-ADM-027',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM027Page />,
  },
  {
    path: '/fraud-queue',
    screenId: 'SCR-ADM-028',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM028Page />,
  },
  {
    path: '/fraud-case/:caseId',
    screenId: 'SCR-ADM-029',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM029Page />,
  },
  {
    path: '/fraud-case',
    screenId: 'SCR-ADM-029',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM029Page />,
  },
  {
    path: '/risk-blocks',
    screenId: 'SCR-ADM-030',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM030Page />,
  },
  {
    path: '/risk-rules',
    screenId: 'SCR-ADM-031',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM031Page />,
  },
  {
    path: '/tenant-list',
    screenId: 'SCR-ADM-034',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM034Page />,
  },
  {
    path: '/tenant-detail',
    screenId: 'SCR-ADM-035',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM035Page />,
  },
  {
    path: '/suspension',
    screenId: 'SCR-ADM-036',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM036Page />,
  },
  {
    path: '/platform-users-and-roles',
    screenId: 'SCR-ADM-037',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM037Page />,
  },
  {
    path: '/platform-configuration',
    screenId: 'SCR-ADM-038',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM038Page />,
  },
  {
    path: '/feature-flags',
    screenId: 'SCR-ADM-039',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM039Page />,
  },
  {
    path: '/notification-templates',
    screenId: 'SCR-ADM-040',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM040Page />,
  },
  {
    path: '/broadcast',
    screenId: 'SCR-ADM-041',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM041Page />,
  },
  {
    path: '/emergency-controls',
    screenId: 'SCR-ADM-042',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM042Page />,
  },
  {
    path: '/provider-configuration',
    screenId: 'SCR-ADM-043',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM043Page />,
  },
  {
    path: '/platform-reports',
    screenId: 'SCR-ADM-044',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM044Page />,
  },
  {
    path: '/audit-search',
    screenId: 'SCR-ADM-045',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM045Page />,
  },
  {
    path: '/notification-centre',
    screenId: 'SCR-ADM-046',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM046Page />,
  },
  {
    path: '/refund-offer-composer',
    screenId: 'SCR-ADM-047',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM047Page />,
  },
  {
    path: '/delivery-failure-case',
    screenId: 'SCR-ADM-048',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM048Page />,
  },
  {
    path: '/adyen-credentials',
    screenId: 'SCR-ADM-049',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM049Page />,
  },
  {
    path: '/email-configurations',
    screenId: 'SCR-ADM-050',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM050Page />,
  },
  {
    path: '/uber-direct-credentials',
    screenId: 'SCR-ADM-051',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM051Page />,
  },
  {
    path: '/beatq-del',
    screenId: 'SCR-ADM-055',
    layoutShell: 'public',
    theme: 'standard',
    element: <BeatqDelRidesPage />,
  },
  {
    path: '/beatq-del/pricing',
    screenId: 'SCR-ADM-056',
    layoutShell: 'public',
    theme: 'standard',
    element: <BeatqDelPricingPage />,
  },
  {
    path: '/finance-controls',
    screenId: 'SCR-ADM-058',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM058Page />,
  },
  {
    path: '/payout-pricing',
    screenId: 'SCR-ADM-057',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM057Page />,
  },
  {
    path: '/sms-configurations',
    screenId: 'SCR-ADM-052',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM052Page />,
  },
  {
    path: '/provider-configuration/adyen-credentials',
    screenId: 'SCR-ADM-049',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM049Page />,
  },
  {
    path: '/provider-configuration/email-configurations',
    screenId: 'SCR-ADM-050',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM050Page />,
  },
  {
    path: '/provider-configuration/uber-direct-credentials',
    screenId: 'SCR-ADM-051',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM051Page />,
  },
  {
    path: '/provider-configuration/beatq-del',
    screenId: 'SCR-ADM-056',
    layoutShell: 'public',
    theme: 'standard',
    element: <BeatqDelPricingPage />,
  },
  {
    path: '/provider-configuration/beatq-del/pricing-policies',
    screenId: 'SCR-ADM-056',
    layoutShell: 'public',
    theme: 'standard',
    element: <BeatqDelPricingPage />,
  },
  {
    path: '/provider-configuration/sms-configurations',
    screenId: 'SCR-ADM-052',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM052Page />,
  },
  {
    path: '/beat-pay-operations',
    screenId: 'SCR-ADM-053',
    layoutShell: 'public',
    theme: 'dense',
    element: <BeatPayOperationsPage />,
  },
  {
    path: '/beat-pay-operations/:businessId',
    screenId: 'SCR-ADM-054',
    layoutShell: 'public',
    theme: 'standard',
    element: <BeatPayAccountDetailPage />,
  },
  {
    path: '/orders/:orderId/investigate',
    screenId: 'SCR-ADM-007',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM007Page />,
  },
  {
    path: '/orders/:orderId/payment',
    screenId: 'SCR-ADM-008',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM008Page />,
  },
  {
    path: '/orders/:orderId/delivery',
    screenId: 'SCR-ADM-009',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM009Page />,
  },
  {
    path: '/cases/:caseId',
    screenId: 'SCR-ADM-004',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM004Page />,
  },
  {
    path: '/customers/:customerId',
    screenId: 'SCR-ADM-010',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM010Page />,
  },
  {
    path: '/customers/:customerId/mirror',
    screenId: 'SCR-ADM-012',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM012Page />,
  },
  {
    path: '/customers/:customerId/impersonate',
    screenId: 'SCR-ADM-013',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM013Page />,
  },
  {
    path: '/businesses/:businessId',
    screenId: 'SCR-ADM-011',
    layoutShell: 'public',
    theme: 'dense',
    element: <SCRADM011Page />,
  },
  {
    path: '/businesses/:businessId/mirror',
    screenId: 'SCR-ADM-012',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM012Page />,
  },
  {
    path: '/businesses/:businessId/impersonate',
    screenId: 'SCR-ADM-013',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM013Page />,
  },
  {
    path: '/audit/:auditRef',
    screenId: 'SCR-ADM-045',
    layoutShell: 'public',
    theme: 'standard',
    element: <SCRADM045Page />,
  },
];

function WithModalOutlet({ children }: { children: ReactElement }) {
  return (
    <>
      {children}
      <Outlet />
    </>
  );
}

const remedyOverlayChildren = [
  { path: 'refund', screenId: 'SCR-ADM-014', element: <SCRADM014Page /> },
  { path: 'goodwill', screenId: 'SCR-ADM-015', element: <SCRADM015Page /> },
  { path: 'waive-fee', screenId: 'SCR-ADM-016', element: <SCRADM016Page /> },
  { path: 'replacement', screenId: 'SCR-ADM-017', element: <SCRADM017Page /> },
  { path: 'cancel', screenId: 'SCR-ADM-018', element: <SCRADM018Page /> },
  { path: 'liability', screenId: 'SCR-ADM-019', element: <SCRADM019Page /> },
];

function PathQueryBridge({
  pathKey,
  queryKey,
  children,
}: {
  pathKey: string;
  queryKey: string;
  children: ReactElement;
}) {
  const params = useParams();
  const [sp] = useSearchParams();
  const location = useLocation();
  const id = params[pathKey];
  if (id && sp.get(queryKey) !== id) {
    const next = new URLSearchParams(sp);
    next.set(queryKey, id);
    return <Navigate to={`${location.pathname}?${next.toString()}`} replace />;
  }
  return children;
}

function LegacySubjectRedirect({
  queryKey,
  buildPath,
  fallback,
}: {
  queryKey: string;
  buildPath: (id: string) => string;
  fallback: ReactElement;
}) {
  const [sp] = useSearchParams();
  const id = sp.get(queryKey);
  if (!id) return fallback;
  return <Navigate to={buildPath(id)} replace />;
}

const routeTree = [
  {
    element: <AdminShell />,
    children: [
      { path: '/admin-dashboard', screenId: 'SCR-ADM-002', element: <SCRADM002Page /> },
      { path: '/case-queue', screenId: 'SCR-ADM-003', element: <SCRADM003Page /> },
      {
        path: '/case-detail',
        screenId: 'SCR-ADM-004',
        element: (
          <LegacySubjectRedirect
            queryKey="caseId"
            buildPath={(id) => caseDetailPath(id)}
            fallback={<SCRADM004Page />}
          />
        ),
      },
      {
        path: '/case-macros',
        screenId: 'SCR-ADM-005',
        element: (
          <LegacySubjectRedirect
            queryKey="caseId"
            buildPath={(id) =>
              `/cases/${encodeURIComponent(id)}/macros?caseId=${encodeURIComponent(id)}`
            }
            fallback={<SCRADM005Page />}
          />
        ),
      },
      {
        path: '/cases/:caseId/macros',
        screenId: 'SCR-ADM-005',
        element: (
          <PathQueryBridge pathKey="caseId" queryKey="caseId">
            <SCRADM005Page />
          </PathQueryBridge>
        ),
      },
      { path: '/macro-management', screenId: 'SCR-ADM-006', element: <SCRADM006Page /> },
      {
        path: '/order-investigation',
        screenId: 'SCR-ADM-007',
        element: (
          <LegacySubjectRedirect
            queryKey="orderId"
            buildPath={(id) => orderInvestigatePath(id)}
            fallback={<SCRADM007Page />}
          />
        ),
      },
      {
        path: '/payment-trace',
        screenId: 'SCR-ADM-008',
        element: (
          <LegacySubjectRedirect
            queryKey="orderId"
            buildPath={(id) => paymentTracePath(id)}
            fallback={<SCRADM008Page />}
          />
        ),
      },
      {
        path: '/delivery-timeline',
        screenId: 'SCR-ADM-009',
        element: (
          <LegacySubjectRedirect
            queryKey="orderId"
            buildPath={(id) => deliveryTimelinePath(id)}
            fallback={<SCRADM009Page />}
          />
        ),
      },
      {
        path: '/customer-360',
        screenId: 'SCR-ADM-010',
        element: (
          <LegacySubjectRedirect
            queryKey="customerId"
            buildPath={(id) => customer360Path(id)}
            fallback={<SCRADM010Page />}
          />
        ),
      },
      {
        path: '/merchant-360',
        screenId: 'SCR-ADM-011',
        element: (
          <LegacySubjectRedirect
            queryKey="businessId"
            buildPath={(id) => merchant360Path(id)}
            fallback={<SCRADM011Page />}
          />
        ),
      },
      { path: '/support-mirror', screenId: 'SCR-ADM-012', element: <SCRADM012Page /> },
      { path: '/impersonation', screenId: 'SCR-ADM-013', element: <SCRADM013Page /> },
      { path: '/issue-refund', screenId: 'SCR-ADM-014', element: <SCRADM014Page /> },
      { path: '/grant-goodwill', screenId: 'SCR-ADM-015', element: <SCRADM015Page /> },
      { path: '/waive-fee', screenId: 'SCR-ADM-016', element: <SCRADM016Page /> },
      { path: '/create-replacement', screenId: 'SCR-ADM-017', element: <SCRADM017Page /> },
      { path: '/cancel-order-support', screenId: 'SCR-ADM-018', element: <SCRADM018Page /> },
      { path: '/attribute-liability', screenId: 'SCR-ADM-019', element: <SCRADM019Page /> },
      { path: '/remedy-history', screenId: 'SCR-ADM-020', element: <SCRADM020Page /> },
      { path: '/escalate', screenId: 'SCR-ADM-021', element: <SCRADM021Page /> },
      {
        path: '/approval-inbox',
        screenId: 'SCR-ADM-022',
        element: (
          <WithModalOutlet>
            <SCRADM022Page />
          </WithModalOutlet>
        ),
        children: [{ path: 'four-eyes', screenId: 'SCR-ADM-023', element: <SCRADM023Page /> }],
      },
      { path: '/four-eyes-confirmation', screenId: 'SCR-ADM-023', element: <SCRADM023Page /> },
      { path: '/moderation-queue', screenId: 'SCR-ADM-024', element: <SCRADM024Page /> },
      { path: '/moderate-review/:itemId', screenId: 'SCR-ADM-025', element: <SCRADM025Page /> },
      { path: '/moderate-review', screenId: 'SCR-ADM-025', element: <SCRADM025Page /> },
      { path: '/moderate-content/:itemId', screenId: 'SCR-ADM-026', element: <SCRADM026Page /> },
      { path: '/moderate-content', screenId: 'SCR-ADM-026', element: <SCRADM026Page /> },
      { path: '/moderation-appeals/:itemId', screenId: 'SCR-ADM-027', element: <SCRADM027Page /> },
      { path: '/moderation-appeals', screenId: 'SCR-ADM-027', element: <SCRADM027Page /> },
      { path: '/fraud-queue', screenId: 'SCR-ADM-028', element: <SCRADM028Page /> },
      { path: '/fraud-case/:caseId', screenId: 'SCR-ADM-029', element: <SCRADM029Page /> },
      { path: '/fraud-case', screenId: 'SCR-ADM-029', element: <SCRADM029Page /> },
      { path: '/risk-blocks', screenId: 'SCR-ADM-030', element: <SCRADM030Page /> },
      { path: '/risk-rules', screenId: 'SCR-ADM-031', element: <SCRADM031Page /> },
      { path: '/tenant-list', screenId: 'SCR-ADM-034', element: <SCRADM034Page /> },
      { path: '/tenant-detail', screenId: 'SCR-ADM-035', element: <SCRADM035Page /> },
      { path: '/tenant-detail/:businessId', screenId: 'SCR-ADM-035', element: <SCRADM035Page /> },
      { path: '/suspension', screenId: 'SCR-ADM-036', element: <SCRADM036Page /> },
      { path: '/suspension/:businessId', screenId: 'SCR-ADM-036', element: <SCRADM036Page /> },
      {
        path: '/tenants/:businessId/suspension',
        screenId: 'SCR-ADM-036',
        element: <SCRADM036Page />,
      },
      { path: '/platform-users-and-roles', screenId: 'SCR-ADM-037', element: <SCRADM037Page /> },
      { path: '/platform-configuration', screenId: 'SCR-ADM-038', element: <SCRADM038Page /> },
      { path: '/feature-flags', screenId: 'SCR-ADM-039', element: <SCRADM039Page /> },
      { path: '/notification-templates', screenId: 'SCR-ADM-040', element: <SCRADM040Page /> },
      { path: '/broadcast', screenId: 'SCR-ADM-041', element: <SCRADM041Page /> },
      { path: '/emergency-controls', screenId: 'SCR-ADM-042', element: <SCRADM042Page /> },
      { path: '/provider-configuration', screenId: 'SCR-ADM-043', element: <SCRADM043Page /> },
      { path: '/platform-reports', screenId: 'SCR-ADM-044', element: <SCRADM044Page /> },
      { path: '/audit-search', screenId: 'SCR-ADM-045', element: <SCRADM045Page /> },
      { path: '/notification-centre', screenId: 'SCR-ADM-046', element: <SCRADM046Page /> },
      { path: '/refund-offer-composer', screenId: 'SCR-ADM-047', element: <SCRADM047Page /> },
      { path: '/delivery-failure-case', screenId: 'SCR-ADM-048', element: <SCRADM048Page /> },
      { path: '/adyen-credentials', screenId: 'SCR-ADM-049', element: <SCRADM049Page /> },
      { path: '/email-configurations', screenId: 'SCR-ADM-050', element: <SCRADM050Page /> },
      { path: '/uber-direct-credentials', screenId: 'SCR-ADM-051', element: <SCRADM051Page /> },
      { path: '/beatq-del', screenId: 'SCR-ADM-055', element: <BeatqDelRidesPage /> },
      { path: '/beatq-del/pricing', screenId: 'SCR-ADM-056', element: <BeatqDelPricingPage /> },
      { path: '/payout-pricing', screenId: 'SCR-ADM-057', element: <SCRADM057Page /> },
      { path: '/finance-controls', screenId: 'SCR-ADM-058', element: <SCRADM058Page /> },
      { path: '/sms-configurations', screenId: 'SCR-ADM-052', element: <SCRADM052Page /> },
      {
        path: '/provider-configuration/adyen-credentials',
        screenId: 'SCR-ADM-049',
        element: <SCRADM049Page />,
      },
      {
        path: '/provider-configuration/email-configurations',
        screenId: 'SCR-ADM-050',
        element: <SCRADM050Page />,
      },
      {
        path: '/provider-configuration/uber-direct-credentials',
        screenId: 'SCR-ADM-051',
        element: <SCRADM051Page />,
      },
      {
        path: '/provider-configuration/beatq-del',
        screenId: 'SCR-ADM-056',
        element: <BeatqDelPricingPage />,
      },
      {
        path: '/provider-configuration/beatq-del/pricing-policies',
        screenId: 'SCR-ADM-056',
        element: <BeatqDelPricingPage />,
      },
      {
        path: '/provider-configuration/sms-configurations',
        screenId: 'SCR-ADM-052',
        element: <SCRADM052Page />,
      },
      {
        path: '/beat-pay-operations',
        screenId: 'SCR-ADM-053',
        element: <BeatPayOperationsPage />,
      },
      {
        path: '/beat-pay-operations/:businessId',
        screenId: 'SCR-ADM-054',
        element: <BeatPayAccountDetailPage />,
      },
      {
        path: '/orders/:orderId/investigate',
        screenId: 'SCR-ADM-007',
        element: (
          <PathQueryBridge pathKey="orderId" queryKey="orderId">
            <WithModalOutlet>
              <SCRADM007Page />
            </WithModalOutlet>
          </PathQueryBridge>
        ),
        children: remedyOverlayChildren,
      },
      {
        path: '/orders/:orderId/payment',
        screenId: 'SCR-ADM-008',
        element: (
          <PathQueryBridge pathKey="orderId" queryKey="orderId">
            <SCRADM008Page />
          </PathQueryBridge>
        ),
      },
      {
        path: '/orders/:orderId/delivery',
        screenId: 'SCR-ADM-009',
        element: (
          <PathQueryBridge pathKey="orderId" queryKey="orderId">
            <SCRADM009Page />
          </PathQueryBridge>
        ),
      },
      {
        path: '/cases/:caseId',
        screenId: 'SCR-ADM-004',
        element: (
          <PathQueryBridge pathKey="caseId" queryKey="caseId">
            <WithModalOutlet>
              <SCRADM004Page />
            </WithModalOutlet>
          </PathQueryBridge>
        ),
        children: [
          ...remedyOverlayChildren,
          { path: 'escalate', screenId: 'SCR-ADM-021', element: <SCRADM021Page /> },
        ],
      },
      {
        path: '/customers/:customerId/mirror',
        screenId: 'SCR-ADM-012',
        element: <SCRADM012Page />,
      },
      {
        path: '/customers/:customerId/impersonate',
        screenId: 'SCR-ADM-013',
        element: <SCRADM013Page />,
      },
      {
        path: '/customers/:customerId',
        screenId: 'SCR-ADM-010',
        element: (
          <PathQueryBridge pathKey="customerId" queryKey="customerId">
            <SCRADM010Page />
          </PathQueryBridge>
        ),
      },
      {
        path: '/businesses/:businessId/mirror',
        screenId: 'SCR-ADM-012',
        element: <SCRADM012Page />,
      },
      {
        path: '/businesses/:businessId/impersonate',
        screenId: 'SCR-ADM-013',
        element: <SCRADM013Page />,
      },
      {
        path: '/businesses/:businessId',
        screenId: 'SCR-ADM-011',
        element: (
          <PathQueryBridge pathKey="businessId" queryKey="businessId">
            <SCRADM011Page />
          </PathQueryBridge>
        ),
      },
      {
        path: '/audit/:auditRef',
        screenId: 'SCR-ADM-045',
        element: (
          <PathQueryBridge pathKey="auditRef" queryKey="q">
            <SCRADM045Page />
          </PathQueryBridge>
        ),
      },
    ],
  },
  {
    element: <AuthLayout surface="admin" />,
    children: [{ path: '/admin-sign-in', screenId: 'SCR-ADM-001', element: <SCRADM001Page /> }],
  },
  { path: '*', element: <NotFoundFallback app="admin-console" /> },
];

export function AppRoutes() {
  return (
    <Suspense fallback={<p role="status">Loading…</p>}>
      <RoutesRenderer />
    </Suspense>
  );
}

function RoutesRenderer() {
  return useRoutes(routeTree);
}
